import { Row, Col, Popover, Form, Switch, Button } from "antd"
import { Guess } from "../types/Guess";
import { SettingOutlined } from '@ant-design/icons';

interface WinnerIndicatorProps {
    guess: Guess,
    values: number[],
    lowerBound: number,
}

const WinnerIndicator = ({ guess, values, lowerBound }: WinnerIndicatorProps) => {
    const value = values[0];
    const proportion = guess.distance / (value - lowerBound) * 100;

    let left = guess.value < value ? `-${proportion}%` : `${proportion}%`;

    return (
        <Popover content={<div className="infoPopup">{guess.name} (<span className="infoPrimary">{guess.value}</span>)</div>} placement="bottom">
            <div className="winnerIndicator" style={guess.value < value ? { left: left } : { left: left }}></div>
        </Popover>
    )
}

interface RankingDisplayProps {
    lowerBound: number,
    upperBound: number,
    rankAmount: number,
    values: number[],
    guesses: Guess[],
    showWinnerPositions: boolean,
    setShowWinnerPositions?: any,
    isMobile: boolean,
}

export const RankingDisplay = ({ lowerBound, upperBound, rankAmount, values, guesses, showWinnerPositions, setShowWinnerPositions, isMobile }: RankingDisplayProps) => {
    return (
        <div>
            {isMobile ? <Popover content={
                <Form>
                    <Form.Item label="Gewinnerpositionen">
                        <Switch onChange={setShowWinnerPositions} value={showWinnerPositions}></Switch>
                    </Form.Item>
                </Form>

            } trigger='click' placement="bottom" title='Einstellungen'>
                <Button icon={<SettingOutlined />} size="large" className="mobileSettings" />
            </Popover> : null}
            <div style={{ width: '100%', margin: '0 auto' }}>
                <div className="rankingBar" style={{ marginLeft: isMobile ? '15%' : '' }}>
                    <Row>
                        <Col span={8} offset={isMobile ? 0 : 4} className="indicationSpanLeft"><div className="indicator"></div></Col>
                        <Col span={8} className="indicationSpanRight">
                            <div className="indicator"></div>
                            {
                                showWinnerPositions &&
                                guesses.slice(0, rankAmount).map(g => <WinnerIndicator guess={g} values={values} lowerBound={lowerBound} />)
                            }
                        </Col>
                        <Col span={1}><div className="indicator"></div></Col>
                    </Row>
                </div>
                <Row style={{ textAlign: 'center' }}>
                    <Col span={8}>
                        <Popover placement="bottom" content={<div className="infoPopup">
                            Schätzungen <span className="infoPrimary">unter {lowerBound}</span> haben keine Chance mehr, unter die <span className="infoPrimary">Top {rankAmount}</span> zu kommen.
                        </div>}>
                            <div className="rankingBarBounds">{lowerBound}</div>
                            <div className="boundsInfo">Untere Grenze</div>
                        </Popover>
                    </Col>
                    <Col span={8}><div className="rankingBarValue">{values.join(', ')}</div></Col>
                    <Col span={8}>
                        <Popover placement="bottom" content={<div className="infoPopup">
                            Schätzungen <span className="infoPrimary">über {upperBound}</span> haben keine Chance mehr, unter die <span className="infoPrimary">Top {rankAmount}</span> zu kommen.
                        </div>}>
                            <div className="rankingBarBounds">{upperBound}</div>
                            <div className="boundsInfo">Obere Grenze</div>
                        </Popover>
                    </Col>
                </Row>
            </div>
        </div>
    );
}